import { Routes, Route, Navigate } from "react-router-dom";
import { Main } from "./main";
import SuspenseWrapper from "../components/SuspenseWrapper";
import { ForgotPassword } from "./auth/ForgotPassword";
import { ResetPassword } from "./auth/ResetPassword";
import { PraxisPlay } from "./praxis-play/PraxisPlay";
import { Certifications } from "./certifications/Certifications";
import { UserCertificationView } from "./certifications/manager-certification/UserCertificationView";
import { CertificationView } from "./certifications/manager-certification/CertificationView";
import { CertificationSimulation } from "./certifications/CertificationSimulation";
import { SessionReportDetails } from "./praxis-play-dashboard/components/SessionReportDetails";
import { Dashboard } from "./dashboard/Dashboard";
import { AuthCallback } from "./auth/sso/AuthCallback";
import { LoginApp } from "./auth/login/LoginApp";
import { CallReport } from "./dashboard/CallReport";
import { SignOut } from "./auth/Signout";
import { TeamDashboard } from "./dashboard/TeamDashboard";
import { ManageUsers } from "./users/Management";
import { CallHistory } from "./praxisplay-call-history/CallHistory";
import { Support } from "./support/Support";
import { FAQs } from "./faqs/FAQs";
import EngagementReport from "./engagement-report/EngagementReport";
import { CertificationProvider } from "./certifications/context/certification-context";
import { useApp } from "../services/app-context";
import { getUrl } from "./certifications/utils/labels";
import BadgeCenter from "./badge-center/BadgeCenter";
import { isEngagementReportDisabled } from "../integrations/posthog/featureFlags";

const RoutesList = () => {
  const { tenantProfile } = useApp();
  const routeNames = tenantProfile?.routeNames || {};
  const url = getUrl("certificationRoute", routeNames);
  return (
    <Routes>
      <Route path="/login" element={<LoginApp />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/saml/callback" element={<AuthCallback />} />

      <Route path="/" element={<Main />}>
        <Route path="praxisplay">
          <Route
            path="session/:sessionID"
            element={
              <SuspenseWrapper>
                <SessionReportDetails />
              </SuspenseWrapper>
            }
          />
          <Route
            path="role-play"
            element={
              <SuspenseWrapper>
                <PraxisPlay />
              </SuspenseWrapper>
            }
          />
        </Route>
        <Route
          path="praxisplay/role-play"
          element={
            <SuspenseWrapper>
              <PraxisPlay />
            </SuspenseWrapper>
          }
        />
        <Route
          path="call-report"
          element={
            <SuspenseWrapper>
              <CallReport />
            </SuspenseWrapper>
          }
        />
        <Route
          path={`${url}`}
          element={
            <SuspenseWrapper>
              <CertificationProvider>
                <Certifications />
              </CertificationProvider>
            </SuspenseWrapper>
          }
        />
        <Route
          path={`${url}/simulation`}
          element={
            <SuspenseWrapper>
              <CertificationProvider>
                <CertificationSimulation />
              </CertificationProvider>
            </SuspenseWrapper>
          }
        />
        <Route
          path={`${url}/review/:certificationAssignmentId`}
          element={
            <SuspenseWrapper>
              <CertificationProvider>
                <CertificationView />
              </CertificationProvider>
            </SuspenseWrapper>
          }
        />
        <Route
          path={`${url}/user/:userId`}
          element={
            <SuspenseWrapper>
              <CertificationProvider>
                <UserCertificationView />
              </CertificationProvider>
            </SuspenseWrapper>
          }
        />
        <Route
          path="admin-settings"
          element={
            <SuspenseWrapper>
              <ManageUsers />
            </SuspenseWrapper>
          }
        />
        <Route
          path="dashboard"
          element={
            <SuspenseWrapper>
              <Dashboard />
            </SuspenseWrapper>
          }
        />
        <Route
          path="badge-center"
          element={
            <SuspenseWrapper>
              <BadgeCenter />
            </SuspenseWrapper>
          }
        />
        <Route
          path="team-dashboard"
          element={
            <SuspenseWrapper>
              <TeamDashboard />
            </SuspenseWrapper>
          }
        />

        <Route
          path="call-history"
          element={
            <SuspenseWrapper>
              <CallHistory />
            </SuspenseWrapper>
          }
        />
        <Route
          path="support"
          element={
            <SuspenseWrapper>
              <Support />
            </SuspenseWrapper>
          }
        />
        <Route
          path="faqs"
          element={
            <SuspenseWrapper>
              <FAQs />
            </SuspenseWrapper>
          }
        />
        <Route
          path="engagement-report"
          element={
            isEngagementReportDisabled() ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <SuspenseWrapper>
                <EngagementReport />
              </SuspenseWrapper>
            )
          }
        />
        <Route
          path="signout"
          element={
            <SuspenseWrapper>
              <SignOut />
            </SuspenseWrapper>
          }
        />
        {/*
          Without this, an unmatched URL matches no branch at all and <Routes>
          renders null, so the layout unmounts and the user gets a blank page.
          Keep the shell mounted with an empty content area instead.

          Deliberately not a redirect: the certification paths above are built
          from tenantProfile, which is null on first render, so a tenant with a
          custom certificationRoute would match this splat briefly and a
          redirect would bounce deep links away before the profile loads.
        */}
        <Route path="*" element={null} />
      </Route>
    </Routes>
  );
};
export default RoutesList;
